(function() {
  'use strict';
  var STORAGE_KEY = 'ravemart_popup_dismissed';
  var DELAY = 10000;
  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;
  var isCheckout = window.location.pathname.indexOf('/checkout') !== -1;
  if (isProductPage || isCheckout) return;
  var dismissed = localStorage.getItem(STORAGE_KEY);
  if (dismissed) { var daysSince = (Date.now() - parseInt(dismissed)) / (1000 * 60 * 60 * 24); if (daysSince < 7) return; }
  var overlay = document.getElementById('popup-overlay');
  var modal = document.getElementById('popup-modal');
  var closeBtn = document.getElementById('popup-close');
  var form = document.getElementById('popup-form');
  var success = document.getElementById('popup-success');
  if (!overlay || !modal) return;

  function showPopup() { modal.classList.add('open'); overlay.classList.add('open'); }
  function hidePopup() { modal.classList.remove('open'); overlay.classList.remove('open'); localStorage.setItem(STORAGE_KEY, Date.now().toString()); }

  var timer = setTimeout(showPopup, DELAY);
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseout', function(e) { if (e.clientY < 5 && !modal.classList.contains('open')) { clearTimeout(timer); showPopup(); } }, { once: true });
  }
  if (closeBtn) closeBtn.addEventListener('click', hidePopup);
  if (overlay) overlay.addEventListener('click', hidePopup);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && modal.classList.contains('open')) hidePopup(); });

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value;
      fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=customer&utf8=%E2%9C%93&customer%5Bemail%5D=' + encodeURIComponent(email) + '&customer%5Btags%5D=newsletter%2Cpopup&customer%5Baccepts_marketing%5D=true'
      }).then(function() { form.style.display = 'none'; if (success) success.style.display = 'block'; setTimeout(hidePopup, 2500); });
    });
  }
})();
